module.exports = __webpack_public_path__ + "static/media/BOB-2023-NafdaLogo@2x.b75cfce8.png";